export default {
  home: "/places",
  place: "/places/:id",
  about: "/about"
};
